import { render } from "./nestingPage.vue?vue&type=template&id=0b06e370"
import script from "./nestingPage.vue?vue&type=script&lang=js"
export * from "./nestingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__